import { SubjectTag } from "components/subject-tag/subject-tag";
import React from "react";
import { colors } from "styles/constants/colors";
import { trimString } from "utils/utils";

export const ClassTags: React.FC<{
  tags: string[] | null;
  trimTag?: boolean;
}> = ({ tags, trimTag }) => {
  const allTagsLength = tags?.length;
  const visibleTagsLength = 2;
  const invisibleTagsLength = Math.max(
    0,
    (allTagsLength || 0) - visibleTagsLength
  );

  return (
    <>
      {tags?.slice(0, visibleTagsLength).map((tag, idx) => (
        <li key={idx}>
          <SubjectTag
            backgroundColor={colors.periwinkle[200]}
            color={colors.periwinkle[700]}
            text={trimTag ? trimString(tag, 12) : tag}
          />
        </li>
      ))}
      {!!invisibleTagsLength && (
        <li>
          <SubjectTag
            backgroundColor={colors.periwinkle[200]}
            color={colors.periwinkle[700]}
            text={`+${invisibleTagsLength}`}
          />
        </li>
      )}
    </>
  );
};
